import { createRouter, createWebHistory } from 'vue-router'

import { checkConversionCardsFeatureFlag } from '@/features/conversion-cards/router/guards/checkConversionCardsFeatureFlag'
import { checkMenuFixerAgentFeatureFlag } from '@/features/menu-fixer-agent/router/guards/checkMenuFixerAgentFeatureFlag'
import { checkSalesFeatureFlag } from '@/features/sales/router/guards/checkSalesFeatureFlag'
import { sendPageLoad } from '@/plugins/analytics'

import { checkAuthenticated } from './guards/checkAuthenticated'
import { checkPermissions } from './guards/checkPermissions'
import { checkSessionExpiration } from './guards/checkSessionExpiration'
import { ensureLocationIdParam } from './guards/ensureLocationIdParam'
import routes from './routes'

export const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'is-active',
  routes,
})

const guards = [
  checkAuthenticated,
  checkSessionExpiration,
  checkPermissions,
  checkConversionCardsFeatureFlag,
  checkMenuFixerAgentFeatureFlag,
  checkSalesFeatureFlag,
  ensureLocationIdParam,
]

router.beforeEach(async (to, from) => {
  for (const guard of guards) {
    const redirect = await guard(to, from)
    if (redirect) return redirect
  }
})

router.afterEach((to) => {
  if (to?.name && typeof to.name === 'string') sendPageLoad(to.name)
})
